import { apiMedService } from '@/api'
// import type {  } from '@/api/models/login'

export const loginApi = apiMedService.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    loginRequest: builder.mutation<any, { email: string; password: string }>({
      query: (params) => ({
        url: '/v1/web/auth/login',
        method: 'POST',
        params,
      }),
    }),
    phoneLoginRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      { phone: string; password: string }
    >({
      query: (params) => ({
        url: '/v1/web/auth/phone-login',
        method: 'POST',
        params,
      }),
    }),
    restoreRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      {
        type: string
        password: string
        confirm: string
        value: string
        code: string
      }
    >({
      query: (params) => ({
        url: '/v1/web/passwords/restore',
        method: 'POST',
        body: params,
      }),
    }),
    sendPasConfirmationRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      {
        type: string
        value: string
      }
    >({
      query: (params) => ({
        url: '/v1/web/passwords/send-confirmation',
        method: 'POST',
        body: params,
      }),
    }),
    validateCodeRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      {
        type: string
        value: string
        code: string
      }
    >({
      query: (params) => ({
        url: '/v1/web/passwords/validate-code',
        method: 'POST',
        body: params,
      }),
    }),
    createPasswordRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      { password: string; confirm: string }
    >({
      query: (params) => ({
        url: '/v1/web/auth/password',
        method: 'POST',
        body: params,
      }),
    }),
    registerByEmailRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      {
        email: string
        code: string
        invatationId?: string
      }
    >({
      query: (params) => ({
        url: '/v1/web/auth/register-by-email',
        method: 'POST',
        body: params,
      }),
    }),
    registerByPhoneRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      {
        phone: string
        code: string
        invatationId?: string
      }
    >({
      query: (params) => ({
        url: '/v1/web/auth/register-by-phone',
        method: 'POST',
        body: params,
      }),
    }),
    sendConfirmationRequest: builder.mutation<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any,
      { type: string; value: string }
    >({
      query: (params) => ({
        url: '/v1/web/auth/send-confirmation',
        method: 'POST',
        body: params,
      }),
    }),
  }),
})

export const {
  useLoginRequestMutation,
  usePhoneLoginRequestMutation,
  useRestoreRequestMutation,
  useSendPasConfirmationRequestMutation,
  useValidateCodeRequestMutation,
  useCreatePasswordRequestMutation,
  useRegisterByEmailRequestMutation,
  useRegisterByPhoneRequestMutation,
  useSendConfirmationRequestMutation,
} = loginApi
